// ToolGateKind, NOT_SIGNED_IN_STATUS, UNKNOWN_OUTCOME_STATUS and SUPERSEDED_APPROVAL_REASON are in
// the gate contract: bazak-mastra docs/hitl-approvals.md.

/** What a gate asked the guest for. Stored history carries it on the call's `artifact`. */
export type ToolGateKind = 'sign_in' | 'confirm' | 'sign_in_confirm';

/** Matched, not parsed: the lane owns the sign-in affordance, so the result carries no link. */
export const NOT_SIGNED_IN_STATUS = 'not_signed_in';

/** A write whose outcome the supplier could not confirm: it may have gone through, so the guest
 *  must check before trying again. */
export const UNKNOWN_OUTCOME_STATUS = 'unknown';

export const SUPERSEDED_APPROVAL_REASON = 'superseded';

/** Our backend reports a lapsed approval as a decline with this reason. */
export const EXPIRED_APPROVAL_REASON = 'expired';

// Mirrors the text our @assistant-ui/react-ai-sdk patch writes on supersession, as `errorText` and
// as the denied approval's `reason`; the two must stay in sync.
export const CANCELLED_BY_SEND = 'User cancelled tool call by sending a new message.';

export function isCancelledBySend(result: unknown): boolean {
  return (result as { error?: unknown } | null)?.error === CANCELLED_BY_SEND;
}

/** Stored history's reason, with no decision, for a gate the run parked on and nobody answered. */
export const UNANSWERED_APPROVAL_REASON = 'unanswered';

export function isUnansweredApproval(approval?: { approved?: boolean; reason?: string }): boolean {
  return approval?.approved === undefined && approval?.reason === UNANSWERED_APPROVAL_REASON;
}

/** The gateway's answer for a call that needs a sign-in, whether the bearer was missing or refused. */
export function isNotSignedInResult(result: unknown): boolean {
  return (result as { status?: unknown } | undefined)?.status === NOT_SIGNED_IN_STATUS;
}

/** A write the supplier could not confirm: neither done nor failed, so no surface may show it
 *  as either. */
export function isUnknownOutcomeResult(result: unknown): boolean {
  return (result as { status?: unknown } | undefined)?.status === UNKNOWN_OUTCOME_STATUS;
}
